import React, { useState, useEffect, useRef } from 'react'
import {
    Box, Modal, Button,
} from "@mui/material";
import { reCalibrateHeadingIcon } from ".././icons";


function ReCalibratingPopup({open, onClose}) {
    return (
        <Modal
            open={open}
            //onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box className="pricing-seasons-popup" sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: '540px',
                //height: '200px',
                bgcolor: '#fff',
                borderRadius: '8px',
            }}>
                <Box className="popup-container">
                    {reCalibrateHeadingIcon}
                    <Box>
                        <div className='popup-title'>Hold On — We’re Updating</div>
                        <div className='popup-msg'>We’re Recalibrating Sell Rate Recommendations. Property Settings Are Temporarily Locked Until the Process Finishes.</div>
                    </Box>
                    <Box className="action-buttons">
                        <Button onClick={onClose} className='btn-group navigate-save-button'>Understood</Button>
                    </Box>
                </Box>
            </Box>

        </Modal>
    )
}

export default ReCalibratingPopup